import { createGlobalStyle } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

interface RichTextEditorOverrideProps {
  Paragraph?: { props: { fontFamily?: string } };
  Heading?: { props: { fontFamily?: string } };
}

/* Reset all styles to default, to make effect of styles from rich text editor */
export const RichTextListGlobalStyle = createGlobalStyle<{ overrides?: RichTextEditorOverrideProps }>`
  .jodit-list h1, .jodit-list h2, .jodit-list h3, .jodit-list h4, .jodit-list h5, .jodit-list h6 {
    all: revert;
    margin: 0;
    font-size: ${pxToRem(16)};
    text-align: left !important;
    font-family: ${({ theme, overrides }) => overrides?.Heading?.props.fontFamily || theme.typography.variants.display4.fontFamily};
    font-weight: inherit;
  }

  .jodit-list p {
    all: revert;
    ${props => props.theme.typography.variants.body2};
    ${({ overrides }) => (overrides?.Paragraph?.props?.fontFamily ? { fontFamily: overrides.Paragraph.props.fontFamily } : {})};
    margin: 0;
    font-size: ${pxToRem(15)};
    text-align: left !important;
  }

  .jodit-list a {
    all: revert;
    &:hover {
      color: ${props => props.theme.colors.linkHover};
    }
    &:active {
      color: ${props => props.theme.colors.linkActive};
    }
  }
`;
